import { UseFormReturn } from "react-hook-form";
import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import CheckoutBillingAddressForm from "@shared/modules/checkout/components/delivery-methods/CheckoutBillingAddressForm/CheckoutBillingAddressForm.web";

function PublicCheckoutBillingAddressForm({
  form,
  onValidFields,
  onInvalidFields,
  id,
  onBillingAddressChange,
}: {
  form: UseFormReturn;
  onValidFields?: () => void;
  onInvalidFields?: () => void;
  id?: string;
  onBillingAddressChange?: (billingAddress: {
    info_home_address_country: string;
  }) => void;
}) {
  return (
    <Box>
      <CheckoutBillingAddressForm
        form={form}
        onValidFields={onValidFields}
        onInvalidFields={onInvalidFields}
        id={id}
        onBillingAddressChange={onBillingAddressChange}
      />
    </Box>
  );
}

export default PublicCheckoutBillingAddressForm;
